var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{attrs:{"button-text":_vm.buttonText,"size":"sm"},on:{"clicked":_vm.launch}})
}
var staticRenderFns = []

export { render, staticRenderFns }